import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-440b1516"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "outer wrap" }
const _hoisted_2 = { class: "contents" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_FooterCopyright = _resolveComponent("FooterCopyright")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LoginForm)
    ]),
    _createVNode(_component_FooterCopyright)
  ]))
}